<template>
  <div class="customers relative">
    <div class="add-button c-float m-b-20 flex is-flex-wrap">
      <div class="flex" style="flex-grow: 1">
        <p class="user-name">{{ $t('invoices') }}</p>
      </div>
    </div>
    <DataTable
      :dropdown=false
      :tableHeader=true
      :tableHead=true
      tableActions="INVOICES"
      tableAPI="INVOICES"
      :actionsOptions="actionsOptions"
      :totalCount="totalCount"
      :checkbox=false
      :field-formatter-configuration="fieldFormatConfig"
      :type=type
      :count="get_invoice_count"
      :list="get_invoice_list"
      :rowActionParameter="rowActionParameter"
      :referenceData="referenceData"
      :filterOptions="filterOptions"
      :customTable=false
      :updateIterator="updateIterator"
      @rowAction="rowAction" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import mixin from '@/mixins/mixins.js';
import Dropdown from '@/components/global/dropdown';
import Popup from '@/components/global/popup';
import DataTable from '@/components/table/index.vue';
import UploadTemplate from '@/components/global/uploadTemplate';
import AddressPicker from '@/components/global/addressPicker/index.vue';
import InputText from '@/components/elements/inputs/text.vue';
import InputSelect from '@/components/elements/inputs/select.vue';
import PhoneSelect from '@/components/elements/inputs/phone.vue';
import formValidator from '@/mixins/formValidator';

/* eslint-disable */
export default {
  name: 'Contacts',
  components: {
    DataTable,
    Dropdown,
    Popup,
    UploadTemplate,
    AddressPicker,
    InputText,
    PhoneSelect,
    InputSelect,
  },
  mixins: [mixin,formValidator],
  data() {
    return {
      updateIterator: 1,
      isTableAllSelected: false,
      selectedItems: [],
      openCreatePopup: false,
      showImportButton: false,
      totalCount: 10,
      rowActionParameter: {
        param: 'id',
        text: `${this.$t('view_invoice')}`,
      },
      type: {
        type: false,
      },
      fieldFormatConfig: {
        logo: [
            {
              type: 'component',
              options: {
                name: 'LogosSVG',
                bind: [{bindKey: 'name', dataKey: 'shipping_agent_name'}, {bindKey : 'size', data: '50'}]
              }
            }
          ],
        booked_price: [
          {
            type: 'currency',
            options: {
              currency_key: 'currency',
            }
          },
        ],
        date: [
          {
            type: 'dateTime',
            options: {
              format: 'dd.MM.yyyy',
            }
          },
        ],
        invoiced_difference: [
          {
            type: 'currency',
            options: {
              currency_key: 'currency',
            }
          },
          {
            type: 'css',
            options: {
              conditionalRule: 'zero_compare',
              conditions: {
                negative: 'text-warning',
                positive : 'text-error',
                equal: 'text-success'
              }
            }
          },
        ],
        invoiced_price: [
          {
            type: 'currency',
            options: {
              currency_key: 'currency',
            }
          },
        ],
        agreement_control: [
          {
            type: 'currency',
            options: {
              currency_key: 'currency',
            }
          },
          {
            type: 'css',
            options: {
              conditionalRule: 'zero_compare',
              conditions: {
                negative: 'text-warning',
                positive : 'text-error',
                zero: 'text-success'
              }
            }
          },
        ],
      },
      referenceData: [
        {
          logo: '',
        },
        {
          invoice_number: `${this.$t('invoice_number')}`,
          date: `${this.$t('date')}`
        },
        {
          booked_price: `${this.$t('booked_price')}`,
          invoiced_difference: `${this.$t('invoiced_difference')}`,
        },
        {
          invoiced_price: `${this.$t('invoiced_price')}`,
          agreement_control: `${this.$t('agreement_control')}`,
        },
      ],
      openImport: false,
      dropdownOptions: [
        {
          text: `${this.$t('Create Contact')}`,
          subText: `${this.$t('Type in manually')}`,
          icon: 'plus',
        },
        {
          text: `${this.$t('Import Contacts')}`,
          subText: `${this.$t('Bulk import from file')}`,
          icon: 'cloudUpload',
        }
      ],
      actionsOptions: [
        {
          text: `${this.$t('delete')}`,
          subText: `${this.$t('Delete selections')}`,
          icon: 'deleteForever',
        },
      ],
      contactAddress: {
        address_1: '',
        address_2: '',
        country_id: '',
        post_code: '',
        city: '',
        state: '',
      },
      contact: {
        name: '',
        company_name: '',
        email: '',
        phone: {
          number: '',
          country: '',
        },
      },
      createType: 2,
      typeOptions: [
        {
          text: `${this.$t('Private')}`,
          value: 2,
        },
        {
          text: `${this.$t('Business')}`,
          value: 1,
        }
      ],
      alternativeAddress:{
        company_name: '',
        name: '',
        address_1: '',
        address_2: '',
        city: '',
        post_code: '',
        country_id: '',
        phone: '',
        email: '',
        state: '',
      }
    };
  },
  computed: {
    ...mapGetters([
      'get_error_message',
      'get_invoice_list',
      'get_invoice_count',
      'get_filters_menu',
      'get_active_filter',
      'get_active_subaccount',
      'get_import_queue',
      'get_all_shipments_query',
    ]),
    filterOptions() {
      return {
        filtersMenu: this.get_filters_menu,
        activeFilter: this.get_active_filter,
        tableName: 'invoices',
        tableApi: 'admin-vendor-invoice/get-list',
        filterFields: {
          invoice_number: {
            label: `${this.$t('invoice_number')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          shipping_agents: {
            label: this.$t('shipping_agent_name'),
            type: 'shippingAgent',
            value: {
              value: [],
              additional: '',
            },
          },
          booked_on_platform: {
            label: `${this.$t('booked_on_platform')}`,
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: `${this.$t('yes')}`, value: '1'},
              {text: `${this.$t('no')}`, value: '0'},
            ],
          },
          invoiced_differences: {
            label: this.$t('show_only_invoiced_differences'),
            type: 'financeTypes',
            value: {
              value: [],
              additional: '',
            },
          },
          agreement_differences: {
            label: this.$t('show_only_agreement_differences'),
            type: 'financeTypes',
            value: {
              value: [],
              additional: '',
            },
          },
          reference: {
            label: `${this.$t('Reference')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          date: {
            label: this.$t('date'),
            type: 'date',
            value: {
              value: null,
              additional: '',
            },
          },
          sender_postcode: {
            label: `${this.$t('sender_post_code')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          sender_country: {
            label: `${this.$t('sender_country_id')}`,
            type: 'country',
            valueKey: 'alpha2',
            value: {
              value: [],
              additional: '',
            },
          },
          receiver_postcode: {
            label: `${this.$t('receiver_post_code')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          receiver_country: {
            label: `${this.$t('receiver_country_id')}`,
            type: 'country',
            valueKey: 'alpha2',
            value: {
              value: [],
              additional: '',
            },
          },
        },
        actionsOptions: [],
      }
    },
  },
  methods: {
    tableSelectionsUpdated(val) {
      this.selectedItems = val.selectedList;
      this.isTableAllSelected = val.selectTotalRows;
    },
    rowAction(val) {
      this.$router.push(`/finance/invoices/${val}`);
    },
  },
  watch: {
    get_import_queue: {
      handler(newValue) {
        newValue.forEach(queObj => {
          if(queObj.templateType == 'contact_fields' && queObj.progressStatus == 100) {
            this.updateIterator++;
          }
        })

      },
      deep: true
    }
  }
};
</script>
